angular.module('ihestiaWidgets.dashboard')
  .factory('IhestiaDashboardPolicyObjectConstants', [function() {
    return {
    };
  }])
  .factory('IhestiaDashboardPolicyObjectModel', ['IHestiaAbstractModel', 'IhestiaDashboardObjectModelConstants',
    function(IHestiaAbstractModel, IhestiaDashboardObjectModelConstants) {

      var PolicyObjectModel = function() {
        this.objectName = 'IhestiaDashboardPolicyObjectModel';

        this.fieldsProperties = {
          id: {
            type: 'string'
          },
          version: {
            type: 'int'
          },
          type: {
            type: 'string'
          },
          policyNumber: {
            type: 'string'
          },
          segment: {
            type: 'string'
          },
          client: {
            type: 'IhestiaDashboardClient'
          }
        };

        this.id = null;
        this.version = null;
        this.type = IhestiaDashboardObjectModelConstants.TYPE_POLICY;
        this.policyNumber = null;
        this.segment = null;
        this.client = null;

      };


      PolicyObjectModel.prototype = IHestiaAbstractModel.prototype;

      return PolicyObjectModel;
    }]);